import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { VaultButton } from '../../../Shared';

export const NavLinkOverride = styled(NavLink)`
  color: black;
  text-decoration: none;
  font-size: 14px;
`;

export const NewProfileButton = styled(VaultButton)`
  width: 102px !important;
`;
